import React, { useEffect } from 'react'
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCrOfPw2cndfOfC7nF5NvtQUIL5Z-BRL5s",
  authDomain: "lifelink-357b2.firebaseapp.com",
  databaseURL: "https://lifelink-357b2-default-rtdb.firebaseio.com",
  projectId: "lifelink-357b2",
  storageBucket: "lifelink-357b2.appspot.com",
  messagingSenderId: "1034245034774",
  appId: "1:1034245034774:web:3e90d8461e4d4aee8ef637",
  measurementId: "G-585JVJBYYW"
};

// Initialize Firebase
export default function Firebase(){
    useEffect(() => {
        const app = initializeApp(firebaseConfig);
        getAnalytics(app);
    }, [])

    return null
}